import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconPencil = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconPencil.dimensions.width} ${IconPencil.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M.79 15.053c.055-.987.106-1.974.174-2.96a.923.923 0 0 1 .184-.45c1.835-2.388 3.675-4.767 5.514-7.151.739-.958 1.477-1.915 2.216-2.867C9.953.232 11.857-.03 13.26 1.022c.29.218.577.432.863.654 1.408 1.085 1.664 3.008.58 4.418-1.968 2.555-3.944 5.101-5.916 7.648-.602.777-1.195 1.555-1.805 2.324a.934.934 0 0 1-.355.278c-1.716.713-3.44 1.414-5.16 2.119-.516.21-.87-.038-.84-.59.05-.94.106-1.88.157-2.82h.004Zm7.755-11.21c-2.1 2.72-4.192 5.43-6.287 8.147 1.383 1.038 2.748 2.064 4.123 3.093 2.1-2.713 4.183-5.409 6.278-8.113-1.37-1.043-2.727-2.077-4.11-3.128h-.004Zm4.78 2.264c.2-.257.397-.5.58-.752a2.012 2.012 0 0 0-.38-2.765c-.315-.252-.644-.5-.972-.735a2.008 2.008 0 0 0-2.617.227c-.26.273-.478.585-.73.897 1.379 1.047 2.74 2.085 4.12 3.132v-.004ZM1.99 13.147c-.077 1.36-.154 2.675-.23 4.026l3.619-1.483c-1.136-.85-2.241-1.683-3.39-2.542Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconPencil.dimensions = {
  width: 16,
  height: 19,
}

export default IconPencil
